import styled from 'styled-components';
import { colours, common, fonts } from 'themes/default';

export const StyledCard = styled.div`
  border-radius: 8px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  background: ${colours.Greyscale.White};
  min-height: 100%;
  width: 284px;
  margin: 25px;
`;

export const CardHeader = styled.div`
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  width: 100%;
  box-sizing: border-box;
  padding: 25px;
  background-color: ${common.homepageCards.header.backgroundColour};
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const StyledImgContainer = styled.div`
  width: 100px;
  height: 100px;
  background-color: ${common.homepageCards.image.backgroundColour};
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledTitle = styled.h2`
  ${fonts.BrandSemiHeadingL};
  color: ${common.homepageCards.header.fontColour};
  font-size: 22px;
  margin: 1.5rem 0 0 0;
  text-align: center;
`;

export const StyledContentContainer = styled.div`
  padding: 25px;
`;
